import { useEligibilityBadgeState } from '../hooks/useEligibilityBadgeState';

import { EligibilityBenefitsView } from './EligibilityBenefitsView';

export { DetailSection, Field } from './EligibilityBenefitsView';

interface Props {
  patientId?: string;
  encounterId?: string;
}

/** Endpoint-backed benefits share the same production view used by stories. */
export const EligibilityFinancialsBlock = ({ patientId, encounterId }: Props) => {
  const { eligibilityData } = useEligibilityBadgeState({ patientId, encounterId });
  return eligibilityData ? <EligibilityBenefitsView data={eligibilityData} /> : null;
};
